module.exports = __webpack_public_path__ + "static/media/ic_userGuide_bedhe_aksara.82229a7f.png";